// extracted by mini-css-extract-plugin
export default {"HomeWrapper":"Home_HomeWrapper__1kvS8","homelogodevfolio":"Home_homelogodevfolio__aDYB5","homeFooter":"Home_homeFooter__qTGxZ"};